export const OVERNIGHT = ["cabana", "carpas", "rodantes"];

export const clp = (n) => "$" + Math.round(Number(n) || 0).toLocaleString("es-CL");

export const toISO = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export const fromISO = (s) => {
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, m - 1, d);
};

export const addDays = (s, n) => {
  const d = fromISO(s);
  d.setDate(d.getDate() + n);
  return toISO(d);
};

export const todayCL = () => new Intl.DateTimeFormat("en-CA", { timeZone: "America/Santiago" }).format(new Date());

export const fmtDate = (s, long = false) =>
  s
    ? fromISO(s).toLocaleDateString("es-CL", long
        ? { weekday: "long", day: "numeric", month: "long", year: "numeric" }
        : { day: "numeric", month: "short", year: "numeric" })
    : "";

export const nightsList = (a, b) => {
  const out = [];
  let d = a;
  while (d < b) {
    out.push(d);
    d = addDays(d, 1);
  }
  return out;
};

export function cleanRut(v) {
  return (v || "").replace(/[^0-9kK]/g, "").toUpperCase();
}

export function validRut(v) {
  const c = cleanRut(v);
  if (c.length < 2) return false;
  const body = c.slice(0, -1);
  const dv = c.slice(-1);
  if (!/^\d+$/.test(body)) return false;
  let sum = 0;
  let f = 2;
  for (let i = body.length - 1; i >= 0; i--) {
    sum += Number(body[i]) * f;
    f = f === 7 ? 2 : f + 1;
  }
  const r = 11 - (sum % 11);
  const exp = r === 11 ? "0" : r === 10 ? "K" : String(r);
  return dv === exp;
}

export function formatRut(v) {
  const c = cleanRut(v);
  if (c.length < 2) return c;
  return Number(c.slice(0, -1)).toLocaleString("es-CL") + "-" + c.slice(-1);
}

export const validEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v || "");

export const CHARGE_LABEL = { unit: "por unidad", person: "por persona", night: "por noche", fixed: "precio fijo" };

export const PRICE_MODE_LABEL = {
  per_person: "por persona",
  per_person_min: "por persona (mínimo)",
  per_group: "por grupo",
  per_night: "por noche",
  per_person_night: "por persona / noche",
  per_unit_night: "por espacio / noche",
};

export const STATUS = {
  pendiente: { label: "Pendiente", cls: "bg-amber-100 text-amber-800 border-amber-200" },
  confirmada: { label: "Confirmada", cls: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  rechazada: { label: "Rechazada", cls: "bg-red-100 text-red-800 border-red-200" },
  cancelada: { label: "Cancelada", cls: "bg-stone-200 text-stone-700 border-stone-300" },
};

export const RESOURCE_LABEL = {
  todo: "Todo el recinto",
  cabana: "Cabaña",
  habitacion: "Habitación adicional",
  tinaja: "Tinaja",
  tinaja_dia: "Tinaja por el día",
  dia_compartido: "Por el día compartido",
  dia_privado: "Por el día privado",
  carpas: "Carpas",
  rodantes: "Casas rodantes",
};

export const waLink = (phone, text) =>
  `https://wa.me/${(phone || "").replace(/\D/g, "")}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

export const minPrice = (e) => {
  const vals = Object.values(e.prices || {}).map(Number).filter((n) => n > 0);
  return vals.length ? Math.min(...vals) : 0;
};
